import { cn } from '@/lib/utils';
import { CLU_COLOURS, type CluColours } from './clu-colours';

interface CopilotIconProps {
  className?: string;
  /** Kept for the call sites; the mark is still. */
  animate?: 'hover' | 'always' | boolean;
}

/**
 * Clu's body in a 511 box: the parrot (crest, tail and folded wing). Shared
 * by the still mark and the animated ones so they swap without a jump.
 */
export function CluBody({ colours }: { colours: CluColours }) {
  return (
    <>
      <path
        d='M292,64 C370,72 425,138 425,222 C425,290 418,330 412,380 C404,440 360,488 300,494 C250,498 200,492 170,482 C140,492 112,502 82,508 C118,478 132,452 136,422 C104,372 92,300 93,228 C93,170 112,128 148,100 C128,72 108,48 80,30 C124,34 160,52 186,78 C186,52 178,26 160,4 C202,18 228,40 240,66 C246,44 256,24 270,8 C282,26 292,44 292,64 Z'
        fill={colours.disc}
      />
      <path
        d='M146,318 C176,306 200,312 204,326 C206,388 220,436 254,478 C196,460 156,410 146,318 Z'
        fill={colours.beak}
      />
    </>
  );
}

/**
 * Clu's mark, in the colours given: Clu's own, or an agent's (every agent
 * is drawn as Clu in its own colour). Drawn inline so it stays sharp at every
 * size; the caller sizes the square.
 */
export function CluBird({
  colours,
  className,
}: {
  colours: CluColours;
  className?: string;
}) {
  return (
    <svg
      viewBox='0 0 511 511'
      fill='none'
      aria-hidden='true'
      focusable='false'
      className={cn('shrink-0 select-none', className)}
    >
      <CluBody colours={colours} />
      <ellipse cx='258' cy='219.5' rx='119' ry='96.5' fill='#fff' />
      <circle cx='212' cy='214.5' r='25' fill={colours.eye} />
      <circle cx='322' cy='199' r='25' fill={colours.eye} />
      <path
        d='M259,225 C272,217 301,218 311,233 C322,251 311,280 279,298 C276,275 270,248 259,225 Z'
        fill={colours.beak}
      />
    </svg>
  );
}

/** Clu's mark, in Clu's blue. */
export const CopilotIcon = ({ className }: CopilotIconProps) => (
  <CluBird colours={CLU_COLOURS} className={className} />
);
